import * as $ from 'jquery';
import 'selectize';
import 'datepicker';
require('datatables.net');
require('datatablesResponsive');
import { memberPortal } from "./member-portal";
import { bookingFormCommon } from "./c005-bookingform-common";

export class covidWaiverPage {
	private form:any = $('#covidwaiver-searchform');
	private $scope:any = $('#covidwaiver-searchresults');
	private memberBase:any = new memberPortal();
	private statusList:any;
	private bcommon = new bookingFormCommon();
	private $checkinError:Array<string> = [];

	/**
	 * initialize all form inputs with focus and filled effects
	 * find all instances of text inputs in all 3 forms on page
	 * combine them into an array and apply effect to all fields
	 * @return {any} [description]
	 */
	initTextInputs(): void {
		let _self = this;
		let $covidwaiverSubmitBtn: any = $('#covidwaiver');
		let $waiverRefSubmitBtn: any = $('.waiverRefSubmit');
		let numberPattern = /^\d+$/;
		let eticketNumberPattern = /^\d{3}-\d{10}$/;
		let ticketNoLimits = [6,14];

		console.log("Entering waiver form!!!!!!!!!!!!")
		$waiverRefSubmitBtn.click((evt:any) => {
			let _self = this;
			evt.preventDefault();
			let $validationSuccess    : any = true;
			let $checkinBookrefErrorValidation: any = $('.checkin-bookingref--error---validation');
			let $checkInBookRefPOD: any = $('.checkin-refno--departure');
			let $checkInBookRefNo: any = $('.waiver--refno');
			let $checkInBookRefValidator : any = $('.waiverRefNo-validator');
			_self.$checkinError = [];
			$checkinBookrefErrorValidation.show();
			$('.covidwaiver-searchresults__table').empty();

			/** validate Booking Ref no. */
			let checkInBookRefNoVal = $checkInBookRefNo.val().trim();

				if(checkInBookRefNoVal == '') {
					let $checkInBookRefNoValidate:any = $checkInBookRefNo.attr('data-bookrefno');
					_self.$checkinError.push('<strong>'+$checkInBookRefNo.parent().find('label').text()+':</strong> '+$checkInBookRefNoValidate);
					$checkInBookRefNo.addClass('has-error');
					$checkInBookRefNo.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else if (
					!ticketNoLimits.includes(checkInBookRefNoVal.length) 
						|| (checkInBookRefNoVal.length == 14 && !eticketNumberPattern.test(checkInBookRefNoVal))
						|| (checkInBookRefNoVal.length == 6 && numberPattern.test(checkInBookRefNoVal))
				) {
					let $checkInBookRefNoValidate:any = $checkInBookRefNo.attr('data-eticketnolen');
					_self.$checkinError.push('<strong>'+$checkInBookRefNo.parent().find('label').text()+':</strong> '+$checkInBookRefNoValidate);
					$checkInBookRefNo.addClass('has-error');
					$checkInBookRefNo.parent().find('.booking-form--title').addClass('has-error');
					$validationSuccess = false;
				} else {
					$checkInBookRefNo.removeClass('has-error');
					$checkInBookRefNo.parent().find('.booking-form--title').removeClass('has-error');
				}
			
			let $validationContainer:any = $checkInBookRefValidator.html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$checkinError.length; i<len; i++) {
			$validationMessagelist.append('<li data-id="'+i+'">' + this.$checkinError[i] + '</li>');
			}

			if($validationSuccess) {
				$checkInBookRefValidator.hide();($checkInBookRefNo.val().trim())
				$checkinBookrefErrorValidation.hide();
				_self.submitCheckIn(((checkInBookRefNoVal.length > 6) ? "ETKT" : "PNR"), $checkInBookRefNo.val());
			} else {
				$checkInBookRefValidator.show();
			}
		});

	}

	submitCheckIn(pnrEticket:string, identification:string): void {
		let _self = this;
		let bcommon = _self.bcommon;
		let getstatusurl: string = '';

		bcommon.preloader();
		if (window.location.hostname === 'localhost'  && window.location.port == "5000") {
			getstatusurl = '/dummy-data/TitleCode.json';
		}
		else {
			if (pnrEticket == 'PNR')
			getstatusurl = '/bin/services/new/waiverstatus?pnr='+identification+'&tktFormat='+pnrEticket;
			else
			getstatusurl = '/bin/services/new/waiverstatus?etkt='+identification+'&tktFormat='+pnrEticket;

		}

		$.ajax({
			type: 'GET',
			url: getstatusurl,
			success: function(data:any) {
				//if (window.location.hostname !== 'localhost') {
				//	json = JSON.parse(json);
				//}
				let json:any = null;
				if (typeof data === 'string') {
					json = JSON.parse(data);
				}	else {
					json = data;
				}
				_self.statusList= json.WaiverStatus;
				var trHTML = '';
				for(let i=0;i<_self.statusList.length;i++)
				{	
					trHTML += '<table class="miles-table responsive" id="waiver-searchtable" style="border: solid 4px #DDD;width: 100%;"><tbody>';
					trHTML += '<tr><th style="padding: 20px;">Booking Number</th><td>' +_self.statusList[i].bookingNumber + '</td></tr>';
					trHTML += '<tr><th style="padding: 20px;">ETicket Number</th><td>' +_self.statusList[i].eTicketNumber + '</td></tr>';
					trHTML += '<tr><th style="padding: 20px;">Request Received Status</th><td>' +_self.statusList[i].requestReceivedStatus + '</td></tr>';
					trHTML += '<tr><th style="padding: 20px;">Request Recevied Date</th><td>' +_self.statusList[i].requestReceivedDate + '</td></tr>';
					trHTML += '<tr><th style="padding: 20px;">Request Process Remarks</th><td>' +_self.statusList[i].requestProcessRemarks + '</td></tr>';
					trHTML += '<tr><th style="padding: 20px;">Request Process Date</th><td>' +_self.statusList[i].requestProcessDate + '</td></tr>';
					trHTML += '<tr><th style="padding: 20px;">Refund Approved Remarks</th><td>' +_self.statusList[i].refundApprovedRemarks + '</td></tr>';
					trHTML += '<tr><th style="padding: 20px;">Refund Approved Date</th><td>' +_self.statusList[i].refundApprovedDate + '</td></tr>';
					trHTML += '<tr><th style="padding: 20px;">Refund Transfer Remarks</th><td>' +_self.statusList[i].refundTransferRemarks + '</td></tr>';
					trHTML += '<tr><th style="padding: 20px;">Refund Transfer Date</th><td>' +_self.statusList[i].refundTransferDate + '</td></tr>';
					trHTML +='</tbody></table>';
				}
				$('.covidwaiver-searchresults__table').append(trHTML);
				if(trHTML!='')
				{
					$('.covidwaiver-searchresults__errormsg').hide();
					$('.covidwaiver-searchresults__table').show();
				}
				else{
					$('.covidwaiver-searchresults__errormsg').show();
					$('.covidwaiver-searchresults__table').hide();
				}
				
			},
			error: function(error:any) {
				$('.covidwaiver-searchresults__errormsg').show();
				$('.covidwaiver-searchresults__table').hide();
				console.log("Error while getting member info", error);
			}
		});	

		bcommon.preloaderClose();
	}

}


let scope:Element = document.querySelector('#covidwaiver-searchform');
if (scope){
	try {
		let bookingformcommon = new bookingFormCommon();
		let covidwaiverPage = new covidWaiverPage();
		covidwaiverPage.initTextInputs();
	} catch(e) {console.error(e);}
}
